module.exports = __webpack_public_path__ + "img/4001.edec2123.png";